import { FaWhatsapp, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/Logo.JPG";
import "../style/Footer.css";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <img
            src={logo}
            alt="Company Logo"
            className="footer-logo"
            onClick={() => navigate("/home")}
          />
          <p>
            We provide accurate and high quality drawings for structural steel
            fabricators. Our detailing well trained staff is proficient of doing
            all type of work complies with AISC, NISC, CISC, ASTM BS, IS CODES,
            requirement of as well as IBC, OHSA.
          </p>
        </div>

        <div className="footer-column">
          <h3>Useful Links</h3>
          <ul>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/aboutus">About Us</Link>
            </li>
            <li>
              <Link to="/sampledrawings">Sample Drawings</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Our Services</h3>
          <ul>
            <li>Structural Steel Detailing</li>
            <li>Connection design services</li>
            <li>Miscellaneous Steel Detailing</li>
            <li>Building information management</li>
            <li>Project Management</li>
            <li>Specialist Report</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Contact Us</h3>
          <p>
            <strong>Email:</strong> sales@steelxengg.com
          </p>
          <p>
            <strong>Phone:</strong> +1 512 764 3655
          </p>
          <p>
            <strong>Address:</strong> Office number 602, Shital Drishti, Dipali
            nagar, Mumbai Naka, Nashik, Maharashtra, 422001
          </p>
          <p> </p>

          <div className="social-icons">
            <a href="https://wa.me/8999720516" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
            <a href="https://www.instagram.com/steel_x_engineering" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/steelx-detailing-and-engg-services-34b956352" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>Copyright © 2021 steelxengg.com</p>
      </div>
    </footer>
  );
};

export default Footer;
